import { render, staticRenderFns } from "./InvoicesTableDestinatary.vue?vue&type=template&id=036fbd5e&"
import script from "./InvoicesTableDestinatary.vue?vue&type=script&lang=js&"
export * from "./InvoicesTableDestinatary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports